import { isUndefined } from "lodash"
import { isEmpty } from "@/utils/validate"

const normalize = (address: string): string => {
    return address.trim().replace(/\s/g, "+")
}

export const placedecode = (
    input: string,
    types: string[],
    country?: string
): Promise<google.maps.places.AutocompletePrediction[]> => {
    if (isEmpty(input)) {
        return Promise.resolve([])
    }

    const opts = !isUndefined(country)
        ? {
              input: normalize(input),
              componentRestrictions: { country },
              types,
          }
        : {
              input: normalize(input),
              types,
          }

    const service = new google.maps.places.AutocompleteService()

    return new Promise((resolve, reject) => {
        service.getPlacePredictions(
            opts,
            (
                predictions: google.maps.places.AutocompletePrediction[],
                status: google.maps.places.PlacesServiceStatus
            ) => {
                if (status === "OK" && predictions.length) {
                    resolve(predictions)
                } else {
                    reject()
                }
            }
        )
    })
}

export const listCities = (
    input: string,
    country?: string
): Promise<string[]> => {
    return new Promise((resolve, reject) => {
        placedecode(input, ["(cities)"], country)
            .then(
                (predictions: google.maps.places.AutocompletePrediction[]) => {
                    resolve(
                        predictions.map(
                            (x: google.maps.places.AutocompletePrediction) =>
                                x.structured_formatting.main_text
                        )
                    )
                }
            )
            .catch(() => {
                reject()
            })
    })
}

export const listStreets = (
    input: string,
    country?: string
): Promise<string[]> => {
    return new Promise((resolve, reject) => {
        placedecode(input, ["geocode"], country)
            .then(
                (predictions: google.maps.places.AutocompletePrediction[]) => {
                    resolve(
                        predictions.map(
                            (x: google.maps.places.AutocompletePrediction) =>
                                x.structured_formatting.main_text
                        )
                    )
                }
            )
            .catch(() => {
                reject()
            })
    })
}

export const listPostalCodes = (
    input: string,
    country?: string
): Promise<string[]> => {
    return new Promise((resolve, reject) => {
        placedecode(input, ["(regions)"], country)
            .then(
                (predictions: google.maps.places.AutocompletePrediction[]) => {
                    resolve(
                        predictions
                            .filter(
                                (
                                    x: google.maps.places.AutocompletePrediction
                                ) => x.types.includes("postal_code")
                            )
                            .map(
                                (
                                    x: google.maps.places.AutocompletePrediction
                                ) => x.structured_formatting.main_text
                            )
                    )
                }
            )
            .catch(() => {
                reject()
            })
    })
}

export default placedecode
